
export interface NavLink {
  to: string;
  label: string;
}

export interface NavItem {
  title: string;
  links: NavLink[];
}

export const navigationData: NavItem[] = [
  {
    title: "Equipe",
    links: [
      { to: "/dudu-daneluci", label: "Dudu Daneluci" },
      { to: "/gabi-vergilio", label: "Gabi Vergílio" },
    ],
  },
  {
    title: "Treinos",
    links: [
      { to: "/treinos#funcional", label: "Treino Funcional do Movimento" },
      { to: "/treinos#recuperacao", label: "Recuperação de Lesões" },
      { to: "/assessoria-ciclismo", label: "Ciclismo e MTB" },
      { to: "/treinos#corrida", label: "Corrida" },
      { to: "/treinos#triathlon", label: "Triathlon" },
      { to: "/treinos#plano", label: "Plano de Treino" },
    ],
  },
  {
    title: "Mais",
    links: [
      { to: "/centro-de-treinamento", label: "Centro de Treinamento" },
      { to: "/catalogo-de-produtos", label: "Catálogo de Produtos" },
      { to: "/training-camps", label: "Training Camps" },
    ],
  },
];
